export enum LangTypeMode {
    DEFAULT = 'DEFAULT',
    ORIGINAL = 'ORIGINAL',
    TRANSLATION = 'TRANSLATION',
}

export enum SettingType {
    CURRENT = 'CURRENT',
    EXPECTED = 'EXPECTED',
}

export enum PrimaryLang {
    CN = 'CN',
    EN = 'EN',
    JP = 'JP',
}
